export enum GameProviderType {
  API = 1,
  BOT = 2
}
